<template>
  <div>
    <v-container
      id="regular-tables"
      fluid
      tag="section"
    >
      <v-row
        class="pa-4"
      >
        <v-col
          class="py-0 my-0"
        />
        <v-btn
          class="ma-2"
          outlined
          color="indigo"
          @click="volverDeVerificarDireccion"
        >
        <v-icon dark>
              mdi-arrow-left
            </v-icon>
          Regresar
        </v-btn>
      </v-row>

      <v-card>
        <v-form
          ref="formVerificarDireccion"
          lazy-validation
          @submit.prevent="save()"
        >
          <base-material-card
            icon="mdi-map-marker"
            title="Confirmar ubicación"
            class="px-5 py-3"
          >
            <v-card-title>
              Dirección
            </v-card-title>
            <v-card-text>

              <v-text-field
                v-model="direccion"
                class="my-2"
                label="Direccion"
                hide-details
                outlined
                required
              />

              <v-btn
                v-if="isVerificadoDireccionGPS"
                color="primary"
                @click="openDireccionCliente"
              >
                Direccion gps
              </v-btn>

              <v-btn
                v-else
                outlined
                @click="openDireccionCliente"
              >
                Direccion gps
              </v-btn>

            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                type="submit"
                :loading="loading"
              >
                Guardar
              </v-btn>
            </v-card-actions>
          </base-material-card>

        </v-form>
      </v-card>
    </v-container>

    <view-map-component
      ref="viewMapFiscal"
      @changeCoordinates="changeCoordinatesCliente"
    />

    <wait-gps-component
    :dialog-wait-gps="dialogWaitGps"
    >
    </wait-gps-component>

    <!-- <dialog-upload
      ref="uploadFileFiscal"
      @onUploadFiscal="onUploadFiscal"
    />
     <dialog-upload
      ref="uploadFileReal"
      @onUploadReal="onUploadReal"
    /> -->

  </div>
</template>

<script>
  import ViewMapComponent from './ViewMapComponent.vue'
  import WaitGpsComponent from './components/WaitGpsComponent.vue'
  // import DialogUpload from './components/dialogUploadComponent.vue'

  // import firebase from 'firebase'
  import 'firebase/storage'

  // const db = firebase.firestore()

  export default {
    components: {
      ViewMapComponent,
      WaitGpsComponent,
      // DialogUpload,
    },
    data () {
      return {
        item: {},
        // loadingFoto: false,
        dialogWaitGps: false,
        direccion: '',
        dialog: false,
        loading: false,
        coordinatesCliente: {
          Latitude: 0,
          Longitude: 0,
        },
        zoomMap: 13,
      }
    },
    computed: {
      // existeFotoFiscal: function () {
      //   return this.item?.foto_direccion_fiscal
      // },
      // existeFotoReal: function () {
      //   return this.item?.foto_direccion_real
      // },
      isVerificadoDireccionGPS: function () {
        return !((this.item?.latitud === '0' || this.item?.latitud === null))
      },
  
    },
    mounted () {
      this.existeItem()
      // this.medioDeContactos = this.$store.state.medioDeContactoEntidadTecnica
      // this.estadosDeContacto = this.$store.state.estadoDeContactoEntidadTecnicaDeConvocatoria
      // this.getDepartamentos()
    },
    methods: {
      async save () {
        if (this.$refs.formVerificarDireccion.validate()) {
          this.loading = true
          
          const response = await fetch(process.env.VUE_APP_BASE_URL_BACKEND + '/distribuidores/prospectar/' + this.item.id, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
            latitud: this.coordinatesCliente.Latitude || '',
            longitud: this.coordinatesCliente.Longitude || '', 
            direccion_cliente: this.direccion || '',
            })
          })
          const data = await response.json()
          if (data.success) {}

          this.loading = false
          if (this.$route.params.isConvocatoria) {
            this.$router.push({ name: 'clientes', params: { convocatoria: this.$route.params.convocatoria } })
          } else {
            this.$router.push({ name: 'clientes' })
          }
        }
      },
      async existeItem () {
        if (!this.$route.params.item) {
          this.$router.push({ name: 'clientes' })
        } else {
          this.item = this.$route.params.item
          this.coordinatesCliente.Latitude = this.item?.latitud
          this.coordinatesCliente.Longitude = this.item?.longitud
          this.direccion = this.item?.direccion_cliente

          // if (this.item?.departamento_fiscal) {
          //   this.departamentoFiscal = await this.item?.departamento_fiscal || ''
          //   if (this.departamentoFiscal) {
          //     await this.onChangeRegionFiscal()
          //   }
          //   this.provinciaFiscal = this.item?.provincia_fiscal || ''
          // }
        }
      },
      openDireccionCliente () {
        this.dialogWaitGps = true
        if (!this.item?.latitud || this.item?.latitud === '0') {
          this.$getLocation().then(coordinates => {
            let Latitude = 0
            let Longitude = 0
            Latitude = coordinates.lat
            Longitude = coordinates.lng
            this.$refs.viewMapFiscal.open({ Latitude: Latitude, Longitude: Longitude })
            this.dialogWaitGps = false
          })
        } else {
            this.$refs.viewMapFiscal.open({ Latitude: this.item.latitud, Longitude: this.item.longitud })
            this.dialogWaitGps = false
        }
      },
      changeCoordinatesCliente (coordinates) {
        if (coordinates) {
          this.coordinatesCliente.Latitude = coordinates.lat
          this.coordinatesCliente.Longitude = coordinates.lng
          this.verificadoDireccionFiscalGPS = true
        } else {
          this.coordinatesCliente.Latitude = this.item.latitud
          this.coordinatesCliente.Longitude = this.item.longitud
          this.verificadoDireccionFiscalGPS = false
        }
      },
      // async subirFotoFiscal (e) {
      //   const newItem = {
      //     id: this.item.id,
      //     foto: this.item?.foto_direccion_fiscal
      //   }
      //   this.$refs.uploadFileFiscal.open(newItem, 'Fiscal')
      // },
      // onUploadFiscal (fotoFiscal) {
      //   this.item.foto_direccion_fiscal = fotoFiscal
      // },
      // async subirFotoReal (e) {
      //   const newItem = {
      //     id: this.item.id,
      //     foto: this.item?.foto_direccion_real
      //   }
      //   this.$refs.uploadFileReal.open(newItem, 'Real')
      // },
      // onUploadReal (fotoReal) {
      //   this.item.foto_direccion_real = fotoReal
      // },
      volverDeVerificarDireccion () {
        if (this.$route.params.isConvocatoria) {
          this.$router.push({ name: 'Entidades de una convocatoria', params: { convocatoria: this.$route.params.convocatoria } })
        } else {
          this.$router.push({ name: 'clientes' })
        }
      },

      // async submit () {
      //   if (this.$refs.form.validate()) {
      //     this.loading = true

      //     const response = await fetch(process.env.VUE_APP_BASE_URL_BACKEND + '/entidad/' + this.item.id, {
      //       method: 'PUT',
      //       headers: {
      //         'Content-Type': 'application/json',
      //       },
      //       body: JSON.stringify({
      //         medio_de_contacto: this.medioDeContactoSeleccionado,
      //         estado: this.estadoDeContactoSeleccionado,
      //       })
      //     })
      //     const data = await response.json()
      //     if (data.success) {}
      
      //     this.loading = false
      //     if (this.$route.params.isConvocatoria) {
      //       this.$router.push({ name: 'Entidades de una convocatoria', params: { convocatoria: this.$route.params.convocatoria } })
      //     } else {
      //       this.$router.push({ name: 'clientes' })
      //     }
      //   }
      // },
      // getDepartamentos () {
      //   this.departamentos = []
      //   this.$store.state.regiones.forEach(region => {
      //     this.departamentos.push(region.NOMBRE)
      //   })
      // },
      // onChangeRegionFiscal () {
      //   var privinciaSeleccionadaByFiltro = this.$store.state.regiones.filter(region => region.NOMBRE === this.departamentoFiscal)
      //   this.provinciasFiscal = privinciaSeleccionadaByFiltro[0]?.PROVINCIAS
      // },
      // onChangeRegionReal () {
      //   var privinciaSeleccionadaByFiltro = this.$store.state.regiones.filter(region => region.NOMBRE === this.departamentoReal)
      //   this.provinciasReal = privinciaSeleccionadaByFiltro[0]?.PROVINCIAS
      // },
    },
  }
</script>
